// Modules
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@dasa-health/components-react'

// Application
import { useDeepLink } from 'hooks'
import { singleSPA } from 'utils'
import { ROUTES_PATH, URL_DOWNLOAD_ANDROID, URL_DOWNLOAD_IOS } from 'constants/index'
import imagedownloadAndroid from 'assets/download-android.svg'
import imageDownloadIOS from 'assets/download-ios.svg'
import imageHeader from 'assets/header.svg'
import imageCentral from 'assets/openApp.svg'

// Components
import {
    ContentContainer,
    Header,
    ImageCentral,
    ImageDownload,
    ImageHeader,
    ImagesContainerStore,
    MainContainer,
    SubTitle,
    Title,
    TitleContainer,
} from './style'

export const DeepLink: React.FC = () => {
    const history = useHistory()
    const { deepLinkToOpenAndroid, deepLinkToOpenIOS, isAndroid, location, isIOS } = useDeepLink()

    const imageDownloadToShow = isIOS ? imageDownloadIOS : imagedownloadAndroid
    const linkStore = isIOS ? URL_DOWNLOAD_IOS : URL_DOWNLOAD_ANDROID

    const naviagteToApp = () => {
        location.replace(isIOS ? deepLinkToOpenIOS : deepLinkToOpenAndroid)
    }

    useEffect(() => {
        setTimeout(() => {
            singleSPA.historyPush(ROUTES_PATH.LANDING_PAGE)
        }, 10000)
    }, [history])

    return (
        <MainContainer>
            <Header>
                <ImageHeader src={imageHeader} />
            </Header>
            <ContentContainer>
                <ImageCentral src={imageCentral} />

                <TitleContainer>
                    <Title>Para continuar, entre no aplicativo</Title>
                </TitleContainer>

                <SubTitle>Acompanhe sua saúde e muito mais!</SubTitle>

                <a href={linkStore}>
                    {(isAndroid || isIOS) && <ImageDownload data-testid="image-download" src={imageDownloadToShow} />}
                </a>

                {!isAndroid && !isIOS && (
                    <ImagesContainerStore>
                        <a href={URL_DOWNLOAD_IOS}>
                            <ImageDownload data-testid="image-download-ios" src={imageDownloadIOS} />
                        </a>
                        <a href={URL_DOWNLOAD_ANDROID}>
                            <ImageDownload data-testid="image-download-android" src={imagedownloadAndroid} />
                        </a>
                    </ImagesContainerStore>
                )}

                <Button data-testid="submit-button" onClick={naviagteToApp} size="default" type="submit" variant="primary">
                    Abrir aplicativo
                </Button>
            </ContentContainer>
        </MainContainer>
    )
}
